import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getFooterDrillDownData: { [key in ModuleConfig]?: ModuleFields[] } = {
  footers: [
    {
      fieldName: "Name (English)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (English)",
      placeholder: "Enter name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Name (Malay)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Name (Malay)",
      placeholder: "Enter name in Malay",
      // validation: { required: "Malay name is required" },
    },
    {
      fieldName: "Name (Mandarin)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Name (Mandarin)",
      placeholder: "Enter name in Mandarin",
      // validation: { required: "Mandarin name is required" },
    },
    {
      fieldName: "Link URL",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Link URL",
      placeholder: "Enter URL",
      validation: { required: "Link is required" },
    },
    {
      fieldName: "Logo Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      label: "Logo Image",
      placeholder: "Upload footer logo image",
      usedFileType: "image/*",
      validation: { required: "Logo image is required" },
    },
    {
      fieldName: "Social Media?",
      fieldValue: "isSocialMedia",
      className: "col-span-6",
      type: "checkbox",
      name: "isSocialMedia",
      formType: "checkbox",
      label: "Is this a Social Media link?",
      placeholder: "Check if social media link",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if logo is published",
    },
  ],
  footerweb: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Copyright Text (English)",
      fieldValue: "copyrightText",
      className: "col-span-6",
      type: "text",
      name: "copyrightText",
      formType: "input",
      label: "Copyright Text (English)",
      placeholder: "Enter copyright text in English",
      validation: { required: "Copyright text is required" },
    },
    {
      fieldName: "Copyright Text (Malay)",
      fieldValue: "field_copyright_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_ms",
      formType: "input",
      label: "Copyright Text (Malay)",
      placeholder: "Enter copyright text in Malay",
    },
    {
      fieldName: "Copyright Text (Mandarin)",
      fieldValue: "field_copyright_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_zh",
      formType: "input",
      label: "Copyright Text (Mandarin)",
      placeholder: "Enter copyright text in Mandarin",
    },
    {
      fieldName: "Registration Text (English)",
      fieldValue: "registrationText",
      className: "col-span-6",
      type: "text",
      name: "registrationText",
      formType: "input",
      label: "Registration Text (English)",
      placeholder: "Enter registration number text",
    },
    {
      fieldName: "Registration Text (Malay)",
      fieldValue: "field_registration_number_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_ms",
      formType: "input",
      label: "Registration Text (Malay)",
      placeholder: "Enter registration text in Malay",
    },
    {
      fieldName: "Registration Text (Mandarin)",
      fieldValue: "field_registration_number_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_zh",
      formType: "input",
      label: "Registration Text (Mandarin)",
      placeholder: "Enter registration text in Mandarin",
    },
    {
      fieldName: "Mobile App Text (English)",
      fieldValue: "mobileAppText",
      className: "col-span-6",
      type: "text",
      name: "mobileAppText",
      formType: "input",
      label: "Mobile App Text (English)",
      placeholder: "Enter mobile app text",
    },
    {
      fieldName: "Mobile App Text (Malay)",
      fieldValue: "field_mobile_app_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_ms",
      formType: "input",
      label: "Mobile App Text (Malay)",
      placeholder: "Enter mobile app text in Malay",
    },
    {
      fieldName: "Mobile App Text (Mandarin)",
      fieldValue: "field_mobile_app_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_zh",
      formType: "input",
      label: "Mobile App Text (Mandarin)",
      placeholder: "Enter mobile app text in Mandarin",
    },
    {
      fieldName: "Terms of Use Text (English)",
      fieldValue: "termsOfUseText",
      className: "col-span-6",
      type: "text",
      name: "termsOfUseText",
      formType: "input",
      label: "Terms of Use Text (English)",
      placeholder: "Enter terms of use text",
    },
    {
      fieldName: "Terms of Use Text (Malay)",
      fieldValue: "field_term_of_use_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_ms",
      formType: "input",
      label: "Terms of Use Text (Malay)",
      placeholder: "Enter terms of use text in Malay",
    },
    {
      fieldName: "Terms of Use Text (Mandarin)",
      fieldValue: "field_term_of_use_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_zh",
      formType: "input",
      label: "Terms of Use Text (Mandarin)",
      placeholder: "Enter terms of use text in Mandarin",
    },
    {
      fieldName: "Terms of Use Link",
      fieldValue: "termsOfUseLink",
      className: "col-span-6",
      type: "text",
      name: "termsOfUseLink",
      formType: "input",
      label: "Terms of Use Link",
      placeholder: "Enter URL for terms of use",
    },
    {
      fieldName: "Privacy Policy Text (English)",
      fieldValue: "privacyPolicyText",
      className: "col-span-6",
      type: "text",
      name: "privacyPolicyText",
      formType: "input",
      label: "Privacy Policy Text (English)",
      placeholder: "Enter privacy policy text",
    },
    {
      fieldName: "Privacy Policy Text (Malay)",
      fieldValue: "field_privacy_policy_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_ms",
      formType: "input",
      label: "Privacy Policy Text (Malay)",
      placeholder: "Enter privacy policy text in Malay",
    },
    {
      fieldName: "Privacy Policy Text (Mandarin)",
      fieldValue: "field_privacy_policy_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_zh",
      formType: "input",
      label: "Privacy Policy Text (Mandarin)",
      placeholder: "Enter privacy policy text in Mandarin",
    },
    {
      fieldName: "Privacy Policy Link",
      fieldValue: "privacyPolicyLink",
      className: "col-span-6",
      type: "text",
      name: "privacyPolicyLink",
      formType: "input",
      label: "Privacy Policy Link",
      placeholder: "Enter URL for privacy policy",
    },
    {
      fieldName: "Play Store Image",
      fieldValue: "playStoreImage",
      className: "col-span-6",
      type: "image",
      name: "playStoreImage",
      formType: "file",
      label: "Play Store Image",
      placeholder: "Upload Play Store logo",
      usedFileType: "image/*",
    },
    {
      fieldName: "Play Store Link",
      fieldValue: "playStoreLink",
      className: "col-span-6",
      type: "text",
      name: "playStoreLink",
      formType: "input",
      label: "Play Store Link",
      placeholder: "Enter Play Store URL",
    },
    {
      fieldName: "App Store Image",
      fieldValue: "appStoreImage",
      className: "col-span-6",
      type: "image",
      name: "appStoreImage",
      formType: "file",
      label: "App Store Image",
      placeholder: "Upload App Store logo",
      usedFileType: "image/*",
    },
    {
      fieldName: "App Store Link",
      fieldValue: "appStoreLink",
      className: "col-span-6",
      type: "text",
      name: "appStoreLink",
      formType: "input",
      label: "App Store Link",
      placeholder: "Enter App Store URL",
    },
  ],
};

export default getFooterDrillDownData;
